module.exports = __webpack_public_path__ + "img/hr-level3addon_mining_tool.d3f80c2a.png";